// removed by extract-text-webpack-plugin
module.exports = {"scope":"m1qYaVi9Jsfz9AKonpuHS","content":"_2ClLmgci-dVoDpe1gKOPDi","ratio1x1":"_1iJ2rVb2-T3Cv6zSIgIXdL","ratio2x1":"_2AI8eHfV9TBYkcizn8g727","ratio3x1":"_3Kc7Yj1ps1nQtZkyXZiKH7","center":"_85JEjB-lJ06QhPNeQOeK1","top":"_20sGX1pAjyRk9uXn5ndZ1V","bottom":"_3hIDkwIShDJ42IuOVo2YHW","container":"_2kuxt9P_rE3sNwVMzkT-28"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/AspectRatio/style.css
// module id = 246
// module chunks = 101